jQuery(document).ready(function($) {

	var contentHeight = $('.data-box').find('.contentWrapper').height();
	var minusIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus-circle"><circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line></svg>';
	var plusIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg><span class="hoverText">Mehr anzeigen</span>';


	if( $(window).width() > 650) {
		$('.contentWrapper').find('p').each(function(index, el) {
			if(isColliding($(this), $('.bottom'))){
				$(this).addClass('hidden');
				$('.data-box').addClass('-shortend');
				$('.plusIcon').show();
			}
		});
	}


	$('.plusIcon').click(function(event) {
		if($('.data-box').hasClass('-shortend')){
			$('.data-box').removeClass('-shortend')
			$('.data-box').addClass('-long');
			$(this).find('.wrapper').html(minusIcon);
			$(this).addClass('-active');
		} else {
			$('.data-box').removeClass('-long')
			$('.data-box').addClass('-shortend');
			$(this).find('.wrapper').html(plusIcon);
			$(this).removeClass('-active');
		}
	});


	/**
	 * Detects if two elements are colliding
	 * taken from https://gist.github.com/jtsternberg/c272d7de5b967cec2d3d
	 *
	 * @link http://stackoverflow.com/questions/5419134/how-to-detect-if-two-divs-touch-with-jquery
	 * @param $div1
	 * @param $div2
	 * @returns {boolean}
	 */
	function isColliding( $div1, $div2 ) {

		// Div 1 data
		var d1_offset             = $div1.offset();
		var d1_height             = $div1.outerHeight( true );
		var d1_width              = $div1.outerWidth( true );
		var d1_distance_from_top  = d1_offset.top + d1_height;
		var d1_distance_from_left = d1_offset.left + d1_width;

		// Div 2 data
		var d2_offset             = $div2.offset();
		var d2_height             = $div2.outerHeight( true );
		var d2_width              = $div2.outerWidth( true );
		var d2_distance_from_top  = d2_offset.top + d2_height;
		var d2_distance_from_left = d2_offset.left + d2_width;

		var not_colliding = ( d1_distance_from_top < d2_offset.top || d1_offset.top > d2_distance_from_top || d1_distance_from_left < d2_offset.left || d1_offset.left > d2_distance_from_left );

		// Return whether it IS colliding
		return ! not_colliding;
	};
});

